var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import "@frameworks/shared-library/stylesheets/components/TransactionJourney/EmandateInfoPage/EmandateInfoPage.scss";
import GenericDetails from "@frameworks/shared-library/components/GenericDetails/GenericDetails";
var EMandateInitiation = function (props) {
    var iconSrc = props.iconSrc, title = props.title, description = props.description, isFromMandate = props.isFromMandate;
    var _a = __read(useState(false), 2), isShowMandateDetails = _a[0], setIsShowMandateDetails = _a[1];
    var handleDivOnClickShowMandateDetails = function () {
        setIsShowMandateDetails(!isShowMandateDetails);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("section", { className: "emandate-content d-flex flex-column align-items-center" },
            React.createElement("div", { className: "text-center" },
                React.createElement("img", { src: iconSrc, alt: "", className: "emandate-icon" }),
                React.createElement("div", { className: "mgt-20 d-flex flex-column align-items-center" },
                    React.createElement("p", { className: "emandate-title DMSansNormal_20_400 mb-0 txt_purple-gray" }, title),
                    React.createElement("p", { className: "emandate-description DMSans_13_400 txt-whispering-periwinkle" }, description && description),
                    (props === null || props === void 0 ? void 0 : props.subDescription) && (React.createElement("p", { className: "emandate__subDescription DMSansNormal_12_400 bg_pale-lemon txt-grey-shade1 w-100 text-start" }, props.subDescription)))),
            isFromMandate && (React.createElement("div", { className: "emandate-details-link d-flex align-items-center justify-content-center DMSans_13_400 mb-16 w-100" },
                React.createElement("div", { tabIndex: 0, className: "d-flex align-items-center gap-1", onClick: handleDivOnClickShowMandateDetails },
                    React.createElement("span", { className: "DMSans_13_400" }, "Mandate Details"),
                    React.createElement("div", null,
                        React.createElement("span", { className: isShowMandateDetails
                                ? "edel-icon-arrow-up-thin"
                                : "edel-icon-arrow-down" })))))),
        isShowMandateDetails ? (React.createElement("div", { className: "w-100 px-2" },
            React.createElement(GenericDetails, { details: props === null || props === void 0 ? void 0 : props.genericDetailsProps }))) : null));
};
export default EMandateInitiation;
